import styled from "styled-components";

export const Container = styled.section`
    position: relative;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0 45px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        padding: 35px 20px 45px;
    }
`
export const Title = styled.h2`
    font-size: 36px;
    text-align: center;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 6px;
    padding: 58px 0;
    position: relative;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: white;
        bottom: 17px;
        right: 50%;
        transform: translateX(50%);
    }
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: white;
        top: 17px;
        right: 50%;
        transform: translateX(50%);
    }
`
export const LinkWrap = styled.div`
    margin-bottom: 80px;
`
export const Text = styled.p`
    color: white;
    line-height: 32px;
    font-size: 16px;
    letter-spacing: 1px;
    text-align: center;
`
export const Link = styled.a`
    color: white;
    text-decoration: none;
`
export const BtnWrap = styled.div`
    display: flex;
    gap: 20px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
        align-items: center;
    }
`
export const Btn = styled.a`
    padding: 18px 28px;
    color: white;
    border: 2px white solid;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 2px;
    text-transform: uppercase;
    border-radius: 3px;
    font-weight: 700;
    transition: 0.2s;
    cursor: pointer;
    &:hover{
        background-color: white;
        color: #252525;
    }
`